import React from "react";
import {
  Button as PrimitiveButton,
  ButtonLink as PrimitiveButtonLink,
} from "./button";

type ButtonVariant =
  | "primary"
  | "dark"
  | "outline"
  | "ghost"
  | "premium"
  | "surface";

const variantMap: Record<
  ButtonVariant,
  "default" | "dark" | "outline" | "ghost" | "premium" | "surface"
> = {
  primary: "default",
  dark: "dark",
  outline: "outline",
  ghost: "ghost",
  premium: "premium",
  surface: "surface",
};

type ButtonProps = React.ComponentPropsWithoutRef<typeof PrimitiveButton> & {
  variant?: ButtonVariant;
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", ...props }, ref) => (
    <PrimitiveButton
      ref={ref}
      variant={variantMap[variant as ButtonVariant]}
      {...props}
    />
  ),
);
Button.displayName = "Button";

type ButtonLinkProps = React.ComponentPropsWithoutRef<
  typeof PrimitiveButtonLink
> & {
  variant?: ButtonVariant;
};

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ variant = "primary", ...props }, ref) => (
    <PrimitiveButtonLink
      ref={ref}
      variant={variantMap[variant as ButtonVariant]}
      {...props}
    />
  ),
);
ButtonLink.displayName = "ButtonLink";
